
  const state = {
    deptTree: []
  }
  const mutations = {
    setDeptTree(state, data) {
       state.deptTree = data
    }
  }
  const actions = {}
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  